import { render, staticRenderFns } from "./Scrapers.vue?vue&type=template&id=5c23d1f7&"
import script from "./Scrapers.vue?vue&type=script&lang=js&"
export * from "./Scrapers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports